import React, { useRef, useState } from "react";
import Contact from "./tabs/contact/Contact";
import Feature from "./tabs/feature/Feature";
import Demo from "./tabs/demo/Demo";
import Modal from "common-ui-components/components/modal";
import headphoneIcon from "common-ui-components/components/icons/support.svg";
import headphoneBlueIcon from "common-ui-components/components/icons/support-blue.svg";
import HorizontalTabs from "common-ui-components/components/horizontal-tabs/HorizontalTabs";
import styles from "./Support.module.css";
import SupportInfo from "./description/SupportInfo";
import Button from "common-ui-components/components/button";
import { notify } from "common-ui-components/components/notification/Notification";
import {
  Failure,
  Success,
} from "common-ui-components/components/notification/templates";

const Support = ({ setOpen }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const formRefs = [useRef(null), useRef(null), useRef(null)];
  const tabs = [
    {
      header: "Contact Support",
      children: (
        <div className={styles.tabContent}>
          <Contact ref={formRefs[0]} />
        </div>
      ),
    },
    {
      header: "Request Demo",
      children: (
        <div className={styles.tabContent}>
          <Demo ref={formRefs[1]} />
        </div>
      ),
    },
    {
      header: "Feature Request",
      children: (
        <div className={styles.tabContent}>
          <Feature ref={formRefs[2]} />
        </div>
      ),
    },
  ];

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      const result = await formRefs[activeTab].current?.submit();
      if (result?.success) {
        notify(<Success>Request sent successfully</Success>);
        setOpen(false);
      } else if (result?.error) {
        notify(<Failure>{result.error}</Failure>);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.headingRow}>
          <span className={styles.titleIcon}>
            <img height={24} width={24} src={headphoneBlueIcon} alt="" />
          </span>
          <h3 className={styles.title}>Contact support</h3>
        </div>

        <HorizontalTabs
          tabs={tabs}
          initialTabIndex={activeTab}
          onTabChange={setActiveTab}
          containerProps={{ className: styles.supportTabs }}
        />

        <div className={styles.footer}>
          <div className={styles.footerActions}>
            <Button children={"Cancel"} onClick={() => setOpen(false)} />
            <Button
              children={
                activeTab === 1
                  ? "Request demo"
                  : activeTab === 2
                    ? "Submit idea"
                    : "Send request"
              }
              variant="primary"
              onClick={handleSubmit}
              loading={submitting}
            />
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <SupportInfo />
      </div>
    </div>
  );
};

export const SupportTrigger = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`${styles.trigger} ${open ? styles.triggerActive : ""}`}
        onClick={() => setOpen(true)}
        aria-label="Contact Support"
        title="Contact Support"
      >
        <img
          className={styles.triggerIcon}
          height={22}
          width={22}
          src={headphoneIcon}
          alt=""
        />
      </button>

      <Modal open={open} setOpen={setOpen} className={styles.modal}>
        <Support setOpen={setOpen} />
      </Modal>
    </>
  );
};

export default Support;
